import React from 'react'
import { PiIdentificationCardThin, PiPasswordLight, PiUserCircleLight } from 'react-icons/pi'
import { Outlet } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useScreenBreakpoint } from '../hooks/toolkit'
import HeaderSpace from './HeaderSpace'
import Sidebar from './Sidebar'
import Tabs from './Tabs'

const ProfileLayout: React.FC = () => {
  const { t } = useTranslation()
  const screenBreakpoint = useScreenBreakpoint()

  const links = [
    {
      label: t('profile.title'),
      to: '/profile',
      Icon: PiUserCircleLight,
      testId: 'profile-section-link',
    },
    {
      label: t('password.title'),
      to: '/profile/new-password',
      Icon: PiPasswordLight,
      testId: 'change-password-section-link',
    },
    {
      label: t('membership.title'),
      to: '/profile/membership',
      Icon: PiIdentificationCardThin,
      testId: 'membership-section-link',
    },
  ]
  return (
    <>
      <HeaderSpace />
      <div className="min-h-[800px] flex flex-col md:flex-row items-stretch dark:bg-primary">
        {screenBreakpoint === 'sm' ? <Tabs links={links} /> : <Sidebar links={links} />}
        <div className="w-full bg-white dark:bg-primary-400">
          <Outlet />
        </div>
      </div>
    </>
  )
}

export default ProfileLayout
